module.exports = __webpack_public_path__ + "img/plus-white.67a3d54b.svg";